import { useTranslation } from 'react-i18next';

const whyItems = [
  { icon: 'ri-shield-check-line', key: 'why.item1' },
  { icon: 'ri-refresh-line', key: 'why.item2' },
  { icon: 'ri-scales-3-line', key: 'why.item3' },
  { icon: 'ri-star-line', key: 'why.item4' },
];

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-12">
          {t('why.title')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyItems.map((item) => (
            <div key={item.key} className="group p-6 rounded-lg bg-background-100 hover:bg-accent-50 transition-colors duration-300 cursor-default">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {t(`${item.key}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`${item.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}